import { Typography } from "../../../../../../shared/frontend/ui";
import type React from "react";
import { typography as designTypography } from "../design-system";

/**
 * „1-20 von 57“ unter einer Liste — nur, wenn es mehrere Seiten gibt. Passt alles auf eine Seite, sagt die
 * Angabe nichts (bei leerer Liste stand sonst „0-0 von 0“ unter der Karte).
 */
export function renderPaginationRange(text: (key: string) => string, total: number, range: [number, number],
  formatCount: (value: number) => string = String): React.ReactNode {
  if (total <= 0 || (range[0] <= 1 && range[1] >= total)) return null;
  return (
    <Typography.Text type="secondary" style={{ fontSize: designTypography.fontSize.compact, whiteSpace: "nowrap" }}>
      {text("Pagination range").replace("{0}", formatCount(range[0])).replace("{1}", formatCount(range[1])).replace("{2}", formatCount(total))}
    </Typography.Text>
  );
}
